import { ZoomIntegration } from "./ZoomIntegration";

export const IntegrationsManagerUI = () => {
  return (
    <div className="max-w-128 p-4">
      <h2 className="mb-4 text-lg font-medium">Integrations</h2>
      <p className="mb-4 text-sm text-gray-400">
        Connect your Frontier account to third party services.
      </p>

      <div className="flex flex-col space-y-4">
        <ZoomIntegration />
      </div>
    </div>
  );
};
